<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>sort</mat-icon>
        <h1>{{'設問情報：並べ替え' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="addQuestion()">
          <mat-icon>sort</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <table>
          <thead>
            <tr>
              <th width="70px">ID</th>
              <th>{{'設問' | translate}}</th>
              <th width="200px">{{'設問タイプ' | translate}}</th>
            </tr>
          </thead>
          <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropSelectItem($event)">
            <tr *ngFor="let question of questions; let i = index" cdkDrag cdkDragLockAxis="y">
              <td width="70px">
                {{ question.question_id }}
              </td>
              <td>
                {{ question.question_names | multiQname:projectLanguages:projectBaseLang }}
              </td>
              <td width="200px" style="overflow: auto;">
                {{ question.question_type }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  
  
  </div>